// extracted by mini-css-extract-plugin
export default {"pageHeader":"styles-module__q6ByL","assetsContainer":"styles-module__ffy66","shareButton":"styles-module__ITFPl"};